class TabsElement extends HTMLElement {
    constructor() {
        super();
        this.tabs = [];
        this.panes = [];
    }

    connectedCallback() {
        this.render();
    }

    render() {
        // Create tab navigation
        const nav = document.createElement("ul");
        nav.classList.add("tab-nav");

        // Create tab content container
        const content = document.createElement("div");
        content.classList.add("tab-content");

        // Process child elements (<tab-item>)
        const tabItems = Array.from(this.children);
        tabItems.forEach((child, index) => {
            const tabName = child.getAttribute("name") || `Tab ${index + 1}`;
            const tabId = `tab-${index}`;

            // Create tab navigation item
            const tab = document.createElement("li");
            tab.classList.add("tab-item");
            tab.textContent = tabName;
            tab.dataset.target = tabId;
            if (index === 0) tab.classList.add("active"); // Default active tab
            this.tabs.push(tab);

            // Create tab content pane
            const pane = document.createElement("div");
            pane.classList.add("tab-pane");
            pane.id = tabId;
            pane.innerHTML = child.innerHTML;
            if (index === 0) pane.classList.add("active"); // Default active pane
            this.panes.push(pane);

            nav.appendChild(tab);
            content.appendChild(pane);
        });

        // Clear original content and append new structure
        this.innerHTML = "";
        this.appendChild(nav);
        this.appendChild(content);

        // Add event listeners for tabs
        this.addEventListeners();
    }

    addEventListeners() {
        this.tabs.forEach((tab) => {
            tab.addEventListener("click", () => {
                // Remove active class from all tabs and panes
                this.tabs.forEach((t) => t.classList.remove("active"));
                this.panes.forEach((p) => p.classList.remove("active"));

                // Add active class to the clicked tab and its corresponding pane
                tab.classList.add("active");
                const targetPane = this.querySelector(`#${tab.dataset.target}`);
                targetPane.classList.add("active");
            });
        });
    }
}

// Define custom elements
customElements.define("tabs-element", TabsElement);
